import { IRootState } from '../../../store'
import { IGenericOptions } from '../store/options.types'

export const getGenericOptionsSelector = (state: IRootState): IGenericOptions => state.options.genericOptions
